<template>
  <div>
    <LRectangle
      v-if="rectangle.bounds != null"
      :bounds="rectangle.bounds"
      :l-style="rectangle.style"
    />
    <SlicedImageLayer :bounds="bounds" :images="images" v-if="images" />
  </div>
</template>
<script>
import { LRectangle } from "vue2-leaflet";
import SlicedImageLayer from "./SlicedImageLayer";
export default {
  name: "DosyaLayer",
  components: {
    LRectangle,
    SlicedImageLayer
  },
  data() {
    return {
      rectangle: {
        bounds: null,
        style: { color: "black", weight: 1 }
      },
      snakeLineLock: false
    };
  },
  computed: {
    bounds() {
      return this.$store.getters.dosyaInfo.bounds;
    },
    images() {
      return this.$store.getters.dosyaInfo.images;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    map() {
      return this.$store.getters.leafletMap;
    }
  },
  watch: {
    baseDate(newVal, oldVal) {
      if (!newVal.isSame(oldVal)) {
        this.loadData();
      }
    }
  },
  created() {
    this.map.on("click", this.showSnakeLine);
    this.map.on("mousemove", this.drawRectangle);
    this.loadData();
  },
  beforeDestroy() {
    this.map.off("click", this.showSnakeLine);
    this.map.off("mousemove", this.drawRectangle);
  },
  mounted() {
    this.$store.commit("SET_USAGE_GUIDE", {
      title: "土砂災害警戒判定値",
      colors: [
        { color: "#10000e", value: "災害切迫【５】" },
        { color: "#a5009c", value: "危険　　【４】" },
        { color: "#ff251b", value: "警戒　　【３】" },
        { color: "#f1e539", value: "注意　　【２】" },
        { color: "#ffffff", value: "今後の情報等に留意" }
      ]
    });
  },
  methods: {
    loadData() {
      this.$store.dispatch("FETCH_DOSYA");
    },
    drawRectangle(e) {
      let lat = Number(e.latlng.lat.toFixed(5));
      let lng = Number(e.latlng.lng.toFixed(5));
      const dy = 2 / 3 / 80;
      const dx = 1 / 80;

      const southwest = [
        lat - (lat / dy - Math.floor(lat / dy)) * dy,
        lng - (lng / dx - Math.floor(lng / dx)) * dx
      ];
      const northeast = [southwest[0] + dy, southwest[1] + dx];
      this.rectangle.bounds = [southwest, northeast];
    },
    showSnakeLine(e) {
      if (this.snakeLineLock === true) {
        return;
      }
      this.snakeLineLock = true;
      setTimeout(() => {
        this.snakeLineLock = false;
      }, 1000);

      let lat = Number(e.latlng.lat.toFixed(5));
      let lng = Number(e.latlng.lng.toFixed(5));

      const div = (val1, val2) => {
        return Math.floor(val1 / val2);
      };

      const mod = (val1, val2) => {
        return val1 % val2;
      };

      // 1次メッシュ上2けた
      let quotient_lat = div(lat * 60, 40);
      let remainder_lat = mod(lat * 60, 40);
      let first2digits = String(quotient_lat).substr(0, 2);
      // 1次メッシュ下2けた
      // eslint-disable-next-line prettier/prettier
      let last2digits = String((lng * 100000 - 100 * 100000) / 100000).substr(0, 2);
      // eslint-disable-next-line prettier/prettier
      let remainder_lng = (lng * 100000 - Number(last2digits) * 100000 - 100 * 100000) / 100000;
      // #1次メッシュ
      let first_mesh = first2digits + last2digits;
      // #2次メッシュ上1けた
      let first1digits = div(remainder_lat, 5);
      remainder_lat = mod(remainder_lat, 5);
      // #2次メッシュ下1けた
      let last1digits = div(remainder_lng * 60, 7.5);
      remainder_lng = mod(remainder_lng * 60, 7.5);
      // #2次メッシュ
      let second_mesh =
        first_mesh +
        String(first1digits).substr(0, 1) +
        String(last1digits).substr(0, 1);
      // #3次メッシュ上1けた
      first1digits = div(remainder_lat * 60, 30);
      remainder_lat = mod(remainder_lat * 60, 30);
      // #3次メッシュ下1けた
      last1digits = div(remainder_lng * 60, 45);
      remainder_lng = mod(remainder_lng * 60, 45);
      // #3次メッシュ
      let third_mesh =
        second_mesh +
        String(first1digits).substr(0, 1) +
        String(last1digits).substr(0, 1);

      const url = `https://d-keikai.pref.fukushima.lg.jp/GraphRainfall.aspx?cd=${third_mesh}&t=1&i=60`;
      window.open(url);
    }
  }
};
</script>
